module.exports = __webpack_public_path__ + "static/media/Carsten Hess.1f75d7ae.png";